/**
 * @generated SignedSource<<5b02082ccf55867492ab223c30290449>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EndAuctionModal_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"UnsupportedBrowserContent_viewer">;
  readonly " $fragmentType": "EndAuctionModal_viewer";
};
export type EndAuctionModal_viewer$key = {
  readonly " $data"?: EndAuctionModal_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"EndAuctionModal_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EndAuctionModal_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UnsupportedBrowserContent_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "7372f277cb8b7842863d9bf78d34ba78";

export default node;
